const timezoneOptions = [
  { text: 'Калининград (UTC+2)', value: 2 },
  { text: 'Москва (UTC+3)', value: 3 },
  { text: 'Самара (UTC+4)', value: 4 },
  { text: 'Екатеринбург (UTC+5)', value: 5 },
  { text: 'Омск (UTC+6)', value: 6 },
  { text: 'Красноярск (UTC+7)', value: 7 },
  { text: 'Иркутск (UTC+8)', value: 8 },
  { text: 'Якутск (UTC+9)', value: 9 },
  { text: 'Владивосток (UTC+10)', value: 10 },
  { text: 'Магадан (UTC+11)', value: 11 },
  { text: 'Камчатка (UTC+12)', value: 12 }
]

const timesOptions = [
  { text: '00:00', value: '00:00' },
  { text: '01:00', value: '01:00' },
  { text: '02:00', value: '02:00' },
  { text: '03:00', value: '03:00' },
  { text: '04:00', value: '04:00' },
  { text: '05:00', value: '05:00' },
  { text: '06:00', value: '06:00' },
  { text: '07:00', value: '07:00' },
  { text: '08:00', value: '08:00' },
  { text: '09:00', value: '09:00' },
  { text: '10:00', value: '10:00' },
  { text: '11:00', value: '11:00' },
  { text: '12:00', value: '12:00' },
  { text: '13:00', value: '13:00' },
  { text: '14:00', value: '14:00' },
  { text: '15:00', value: '15:00' },
  { text: '16:00', value: '16:00' },
  { text: '17:00', value: '17:00' },
  { text: '18:00', value: '18:00' },
  { text: '19:00', value: '19:00' },
  { text: '20:00', value: '20:00' },
  { text: '21:00', value: '21:00' },
  { text: '22:00', value: '22:00' },
  { text: '23:00', value: '23:00' }
]

const autoCloseOptions = [
  { text: '30м', value: '1800' },
  { text: '1ч', value: '3600' },
  { text: '2ч', value: '7200' },
  { text: '6ч', value: '21600' },
  { text: '24ч', value: '86400' }
]

const daysOfWeek = [
  { text: 'Пн.', value: 1 },
  { text: 'Вт.', value: 2 },
  { text: 'Ср.', value: 3 },
  { text: 'Чт.', value: 4 },
  { text: 'Пт.', value: 5 },
  { text: 'Сб.', value: 6 },
  { text: 'Вс.', value: 7 }
]

export {
  timezoneOptions,
  timesOptions,
  autoCloseOptions,
  daysOfWeek
}

